import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adresse-no-found',
  templateUrl: './adresse-no-found.component.html',
  styleUrls: ['./adresse-no-found.component.scss']
})
export class AdresseNoFoundComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
